import { render, staticRenderFns } from "./LCSupervisionCourse.vue?vue&type=template&id=5aa9f611&scoped=true&"
import script from "./LCSupervisionCourse.vue?vue&type=script&lang=js&"
export * from "./LCSupervisionCourse.vue?vue&type=script&lang=js&"
import style0 from "./LCSupervisionCourse.vue?vue&type=style&index=0&id=5aa9f611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9f611",
  null
  
)

export default component.exports